import {
  USER_ACTION_TYPES as SharedUserActionTypes,
} from "shared/dist/types/UserAction";

import type {
  UserAction as SharedUserAction,
  UserActionType,
} from "shared/dist/types/UserAction";

export type { UserActionType };

export const USER_ACTION_TYPES = SharedUserActionTypes;

export default interface UserAction extends SharedUserAction {}
